import { logout as ptLogout } from '@pt/api/adv'
import { getToken, removeToken } from '@pt/utils/auth'

export const logout = async () => {
  const logoutCallback = () => {
    removeToken()
    // 跳转到首页
    navigateToPlayturboDispatcher()
  }
  if (getToken()) {
    await ptLogout()
    logoutCallback()
  } else {
    logoutCallback()
  }
}

export function navigateToPlayturboDispatcher(): void {
  window.location.href = process.env.PT!
}

// 调整到视频项目列表页面
export function navigateToPlayturboVideoList(): void {
  if (process.env.PT) {
    // fix: 跳之前，去除当前页面的名称，不然会被认为还是之前的编辑器页面，而被后续的逻辑找到
    window.name = ''

    window.location.href = process.env.PT + '#/my-project/video/normal'
  }
}

export function navigateToPlayturboVideoTemplateList(): void {
  if (process.env.PT) {
    // fix: 跳之前，去除当前页面的名称，不然会被认为还是之前的编辑器页面，而被后续的逻辑找到
    window.name = ''

    window.location.href = process.env.PT + '#/creative-assets/template/video'
  }
}
